import {
  ChartTypeEnum,
  FilterOperatorEnum,
  MeasureAggregatorEnum,
  PathContentType,
} from '@/types/schema';
interface Params {
  learnerId: string;
  assesmentIds: string[];
  contentIds: string[];
  pathId: string;
}

export const getLearnerPathContentsQuery = (params: Params): any => {
  const { learnerId, assesmentIds, contentIds, pathId } = params;

  const contentFilters = [];

  if (contentIds.length) {
    contentFilters.push({
      property: 'entityId',
      operator: FilterOperatorEnum.In,
      value: contentIds,
    });
  }

  if (assesmentIds.length) {
    contentFilters.push({
      operator: FilterOperatorEnum.And,
      filters: [
        { property: 'parentEntityId', operator: FilterOperatorEnum.In, value: [pathId] },
        { property: 'entityId', operator: FilterOperatorEnum.In, value: assesmentIds },
      ],
    });
  }

  return {
    chartType: ChartTypeEnum.Table,
    dimensions: ['path_content_learner_profile'],
    measures: [
      { field: 'performance_progress', aggregator: MeasureAggregatorEnum.Sum },
      { field: 'certification_score_percentage', aggregator: MeasureAggregatorEnum.Sum },
    ],
    properties: ['parent_entity_id'],
    sort: [{ field: 'content_progress_sum', direction: 'desc' }],
    filterGroup: {
      operator: FilterOperatorEnum.And,
      filters: [
        { property: 'learner', operator: FilterOperatorEnum.In, value: [learnerId] },
        { operator: FilterOperatorEnum.Or, filters: contentFilters },
      ],
    },
  };
};

export const addIsOptionalInContentData = (
  allChildResourceConfigsMap: Map<string, boolean>,
  contentData?: any[],
  key: string = 'entityId',
) => {
  const updatedChartData = contentData?.map((data) => ({
    ...data,
    isOptionalContent: allChildResourceConfigsMap.get(data?.[key]),
  }));
  return updatedChartData;
};

export const getOptionalContentInPathMap = (pathContent?: PathContentType) => {
  const allChildResourceConfigsMap = new Map<string, boolean>();
  pathContent?.sections?.forEach((section) => {
    section.childResourceIds?.forEach((resourceId) =>
      allChildResourceConfigsMap.set(resourceId, false),
    );
    section?.childResourceConfigs?.forEach((config) =>
      allChildResourceConfigsMap.set(config.resourceId, config.isOptional),
    );
  }, new Map<string, boolean>());
  return allChildResourceConfigsMap;
};
